var zIndex = {
    tooltip: 6000,
};
export default zIndex;
//# sourceMappingURL=zIndex.js.map